<template>
  <section class="d-flex" ref="dropdown">
    <div class="d-flex magic-button p-relative">
    <BellIcon class="cursor-pointer p-1 br-1 magic-button"
              :class="{ 'bg-danger wiggle': unreadNoficationsCount > 0}"
              @click.native="showDropDown = !showDropDown"/>
    </div>

    <TransitionFade>
      <div v-show="showDropDown" class="p-absolute">
        <div class="better-navbar-dropdown is-active moreDropdown ">
          <div class="d-flex justify-space-between align-items-center mb-2">
            <div class="d-flex flex-align-center flex-wrap">
              <h3 class="fs-6 mr-2">Notifications</h3>
              <small v-if="!loading" class="fs-4" :class="{ 'text-danger': unreadNoficationsCount > 0}">
                ({{ unreadNoficationsCount }} unread)
              </small>
            </div>
            <button v-show="unreadNoficationsCount > 0 && !loading" @click="clearNotifications()"
              class="button is-small" :class="{ 'is-loading': dismissing }">
              mark all read
            </button>

            <button class="delete ml-2" @click="showDropDown = false"></button>
          </div>


          <Loader v-if="loading"/>
          <section v-else-if="notifications.length > 0" class="overflow-y-after-600px">
            <Notification v-for="notif in notifications"
              :key="notif.id"
              :notification="notif"
            />
          </section>

        </div>
      </div>
    </TransitionFade>
  </section>
</template>

<script>
import Loader from './Loader.vue'
import Notification from './Notification.vue'
import BellIcon from './BellIcon.vue'
import TransitionFade from './TransitionFade'

import store from '../store'

import {
  dismissAllNotifications,
  pollNotifications,
  fetchNotifications,
} from '../actionTypes'

export default {
  name: 'NavbarNotifications',
  components: {
    Loader,
    Notification,
    BellIcon,
    TransitionFade,
  },
  data () {
    return {
      showDropDown: false,
      dismissing: false,
    }
  },
  async mounted () {
    await store.dispatch(fetchNotifications)

    this.interval = setInterval(() => {
      if (store.state.user.authenticated) {
        store.dispatch(pollNotifications, store.state.mostRecentNotification)
      }
    }, 30000)

    const newnotifications = this.unreadNoficationsCount > 0
    this.handleNotificationsAsterisk(newnotifications)

    document.addEventListener('mouseup', this.handleGeneralClick)
  },
  beforeDestroy () {
    document.removeEventListener('mouseup', this.handleGeneralClick)

    clearInterval(this.interval)
  },
  methods: {
    handleNotificationsAsterisk (newNotifications) {
      const startAsterisks = /^\**/g
      // add a preceding asterisk if there are notifications, if there aren't
      // notifications, remove the asterisk if preset
      // NOTE: we also strip the preceding asterisks to prevent adding multiple
      if (newNotifications) {
        document.title = '* ' + document.title.replace(startAsterisks, '')
      } else if (startAsterisks.test(document.title)) {
        document.title = document.title.replace(startAsterisks, '')
      }
    },
    handleGeneralClick (e) {
      const element = this.$refs.dropdown
      if (element == null) return
      const clickedInComponent = element.contains(e.target)
      if (clickedInComponent) return
      this.showDropDown = false
    },
    async clearNotifications () {
      this.dismissing = true
      await store.dispatch(dismissAllNotifications)
      this.dismissing = false
    },
  },
  computed: {
    notifications () {
      return store.state.notifications
    },
    unreadNoficationsCount () {
      return store.state.notifications.filter(x => !x.dismissed).length
    },
    loading () {
      return store.state.loadingNotificationsData
    },
  },
  watch: {
    unreadNoficationsCount (val) {
      const newnotifications = val > 0
      this.handleNotificationsAsterisk(newnotifications)
    },
  },
}

</script>

<style lang="scss" scoped>
.moreDropdown {
  padding: 1rem;
  opacity: 1;
  pointer-events: auto;
}

.wiggle {
  animation: wiggle 2s infinite;
  transform: rotate(0);
}

@keyframes wiggle {
  0% {
    transform: rotate(0);
  }
  25% {
    transform: rotate(5deg);
  }
  50% {
    transform: rotate(-5deg);
  }
}


.overflow-y-after-600px {
  max-height: 600px;
  overflow-y: auto;
}

.better-navbar-dropdown {
  right: 0;
  left: auto;
  top: calc(100% + (10px));
  display: block;
  position: absolute;
  min-width: 26rem;
  background-color: white;
  font-size: 0.875rem;
  z-index: 20;
  border-radius: 5px;
  border-top: none;
  box-shadow: 0 8px 8px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  transform: translateY(-5px);
  transition-duration: 86ms;
  transition-property: opacity, transform;

  @media (max-width: 500px) {
    left: 5px;
    right: 5px;
    min-width: auto;
    margin-right: 0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// NavbarNotifications.vue?4e55b75a